module.exports = __webpack_public_path__ + "img/參加抽獎.a7b604e1.png";